import { sortBy } from 'underscore';
import { fromJS, Map, List } from 'immutable';

import config from '../../config';
import {
  SAVED_HARVCO_TAG_SUCCESS,
  LOADING_PROJECT_SUGGESTION,
  LOADED_PROJECT_SUGGESTION_SUCCESS,
  RESET_ERROR_LIST,
  REVERT_PROJECT_CHANGES,
  UPDATE_PROJECT_COMMON_INFO,
  LOADED_PROJECT_SUCCESS,
  SHOW_PROJECT_LOADING,
  REQUEST_API_PROJECT_FAILURE,
  LOADING_PROJECT_TYPES_SUCCESS,
} from '../../actions/eproject/main';
import {
  SHOW_USERS_LOADING,
  REQUEST_API_USERS_FAILURE,
  LOADED_USERS_SUCCESS,
  LOADED_USERS_SUGGESTIONS_SUCCESS,
  LOADING_USERS_SUGGESTION,
  SAVED_USERS_SUCCESS,
} from '../../actions/eproject/user';
import {
  SHOW_INDUSTRIES_LOADING,
  REQUEST_API_INDUSTRIES_FAILURE,
  LOAD_INDUSTRIES_SUCCESS,
  LOADED_INDUSTRIES_SUGGESTIONS_SUCCESS,
  LOADING_INDUSTRIES_SUGGESTION,
  DELETING_INDUSTRY_ROW,
  DELETED_INDUSTRY_ROW_SUCCESS,
  DELETED_INDUSTRY_ROW_FAILURE,
  SAVED_INDUSTRIES_SUCCESS,
  UPDATE_INDUSTRY_TAGS,
} from '../../actions/eproject/industry';
import {
  LOADING_UNIVERSE,
  LOADED_UNIVERSE_FAILURE,
  LOADED_UNIVERSE_SUCCESS,
  LOADING_SORTED_UNIVERSE,
  LOADED_SORTED_UNIVERSE_FAILURE,
  LOADED_SORTED_UNIVERSE_SUCCESS,
  SORT_UNIVERSE,
  RELOADING_UNIVERSE,
  RELOADED_UNIVERSE_SUCCESS,
  RELOADED_UNIVERSE_FAILURE,
} from '../../actions/eproject/universe';
import {
  REQUEST_API_HARVCO_TAGS_FAILURE,
  SHOW_HARVCO_TAGS_LOADING,
  LOADED_HARVCO_TAGS_SUCCESS,
} from '../../actions/eproject/harvcoTag';
import getErrorResponse from '../../utils/getErrorResponse';
import { spy, setIn, setOriginalIn, revert, getIn } from '../../utils/ChangeSpy';

const FIELDS_TO_SPY = ['status', 'category', 'details', 'selectedBICs', 'selectedBMs'];

const defaultState = spy(
  fromJS({
    projectLoading: false,
    userLoading: false,
    industryLoading: false,
    harvoTagLoading: false,
    universeLoading: false,
    userSuggestions: [],
    harvcoLeadSuggestions: [],
    clientLeadSuggestions: [],
    industrySuggestions: [],
    projectTypes: [],
    industrySuggestionRequestId: '',
    userSuggestionRequestId: '',
    projectRequestId: '',
    targetSortField: '',
    targetSortDirection: '',
    errors: [''],
    bic: [],
    bm: [],
    selectedBICs: [],
    selectedBMs: [],
    status: false,
    category: '',
    details: '',
  }),
  FIELDS_TO_SPY,
);

export default function(state = defaultState, action) {
  switch (action.type) {
    case SHOW_PROJECT_LOADING:
      return state.set('projectLoading', true);

    case SHOW_USERS_LOADING:
      return state.set('userLoading', true);

    case DELETING_INDUSTRY_ROW:

    // fallthrough
    case SHOW_INDUSTRIES_LOADING:
      return state.set('industryLoading', true);

    case SHOW_HARVCO_TAGS_LOADING:
      return state.set('harvoTagLoading', true);

    case LOADING_UNIVERSE:

    // fallthrough
    case RELOADING_UNIVERSE:

    // fallthrough
    case LOADING_SORTED_UNIVERSE:
      return state.set('universeLoading', true);

    case REQUEST_API_PROJECT_FAILURE:
      return state.merge({
        projectLoading: false,
        errors: state.get('errors').concat(getErrorResponse(action.response)),
      });

    case REQUEST_API_USERS_FAILURE:
      return state.merge({
        userLoading: false,
        errors: state.get('errors').concat(getErrorResponse(action.response)),
      });

    case REQUEST_API_INDUSTRIES_FAILURE:
      return state.merge({
        industryLoading: false,
        errors: state.get('errors').concat(getErrorResponse(action.response)),
      });

    case REQUEST_API_HARVCO_TAGS_FAILURE:
      return state.merge({
        harvoTagLoading: false,
        errors: state.get('errors').concat(getErrorResponse(action.response)),
      });

    case LOADED_UNIVERSE_FAILURE:

    // fallthrough
    case RELOADED_UNIVERSE_FAILURE:

    // fallthrough
    case LOADED_SORTED_UNIVERSE_FAILURE:
      return state.merge({
        universeLoading: false,
        errors: state.get('errors').concat(getErrorResponse(action.response)),
      });

    case LOADING_PROJECT_TYPES_SUCCESS:
      return state.merge({
        projectTypes: action.response.data,
      });

    case DELETED_INDUSTRY_ROW_FAILURE:
      return state.merge({
        industryLoading: false,
        errors: state.get('errors').concat(getErrorResponse(action.response)),
      });

    case SAVED_HARVCO_TAG_SUCCESS:
      return spy(setValueAsOriginalByMap(state, action.fields), FIELDS_TO_SPY).set('projectLoading', false);

    // fallthrough
    case LOADED_HARVCO_TAGS_SUCCESS: {
      if (action.response) {
        return spy(state.merge(mapResponse(action)), FIELDS_TO_SPY).set('harvoTagLoading', false);
      }
    }

    // fallthrough
    case SAVED_USERS_SUCCESS:

    // fallthrough
    case LOADED_USERS_SUCCESS:
      return state.set('userLoading', false);

    case SAVED_INDUSTRIES_SUCCESS:

    // fallthrough
    case DELETED_INDUSTRY_ROW_SUCCESS:
      return state.set('industryLoading', false);

    case LOAD_INDUSTRIES_SUCCESS:
      return loadIndustry(state.set('industryLoading', false), action);

    case LOADED_UNIVERSE_SUCCESS:

    // fallthrough
    case RELOADED_UNIVERSE_SUCCESS:

    // fallthrough
    case LOADED_SORTED_UNIVERSE_SUCCESS:
      return state.set('universeLoading', false);

    case LOADING_INDUSTRIES_SUGGESTION:
      return state.set('industrySuggestionRequestId', action.requestId);

    case LOADING_USERS_SUGGESTION:
      return state.set('userSuggestionRequestId', action.requestId);

    case LOADING_PROJECT_SUGGESTION:
      return state.merge({
        projectRequestId: action.requestId,
        [`${action.field}Suggestion`]: List(),
      });

    case LOADED_USERS_SUGGESTIONS_SUCCESS:
      return state.set('userSuggestions', loadSuggestions(state, action, 'user'));

    case LOADED_PROJECT_SUGGESTION_SUCCESS:
      return loadProjectSuggestions(state, action);

    case LOADED_INDUSTRIES_SUGGESTIONS_SUCCESS:
      return state.set('industrySuggestions', loadSuggestions(state, action, 'industry'));

    case SORT_UNIVERSE:
      return state.merge({
        targetSortField: action.field,
        targetSortDirection: action.direction,
      });

    case LOADED_PROJECT_SUCCESS: {
      return state.set('projectLoading', false);
    }

    case RESET_ERROR_LIST:
      return state.set('errors', List());

    case UPDATE_INDUSTRY_TAGS:
      return updateSelectedIndustryTags(state, action);

    case UPDATE_PROJECT_COMMON_INFO:
      return setIn(state, action.field, action.value);

    case REVERT_PROJECT_CHANGES: {
      return revert(state);
    }

    default:
      return state;
  }
}

function loadIndustry(state, { response: { data } }) {
  let selectedBICs = [];
  const bic = data.ceoProjectIndustryCategories.map(i => {
    selectedBICs.push(i.id);

    return {
      id: i.id,
      name: i.category,
      deprecated: false,
      deletedAt: i.deletedAt,
    };
  });

  let selectedBMs = [];
  const bm = data.ceoProjectBusinessModels.map(i => {
    selectedBMs.push(i.id);

    return {
      id: i.id,
      name: i.category,
      deprecated: false,
      deletedAt: i.deletedAt,
    };
  });

  selectedBICs = fromJS(sortBy(selectedBICs));
  selectedBMs = fromJS(sortBy(selectedBMs));

  let nextState = state.set('bm', fromJS(bm)).set('bic', fromJS(bic));

  nextState = setOriginalIn(nextState, 'selectedBICs', selectedBICs);
  nextState = setOriginalIn(nextState, 'selectedBMs', selectedBMs);
  nextState = setIn(nextState, 'selectedBICs', selectedBICs);

  return setIn(nextState, 'selectedBMs', selectedBMs);
}

function updateSelectedIndustryTags(state, action) {
  const { tags, models } = action;
  const selectedBICs = [];
  const selectedBMs = [];
  const ind = state.get('bic').filter(b => b.get('deprecated'));
  const bic = tags.map(t => {
    selectedBICs.push(t.id);

    return {
      id: t.id,
      name: t.category,
      deprecated: false,
      deletedAt: t.deletedAt,
    };
  });
  const bm = models.map(t => {
    selectedBMs.push(t.id);

    return {
      id: t.id,
      name: t.category,
      deprecated: false,
      deletedAt: t.deletedAts,
    };
  });

  return state
    .set('bm', fromJS(bm))
    .set('bic', fromJS(bic).concat(ind))
    .setIn(['selectedBICs', 'value'], fromJS(sortBy(selectedBICs)))
    .setIn(['selectedBMs', 'value'], fromJS(sortBy(selectedBMs)));
}

/**
 * Insert an empty row to list.
 *
 * @param list {Immutable.List} List.
 */
export function addEmptyRow(list) {
  let newList = list.map(it => it.merge({ mode: config.VIEW_MODE, name: it.get('origin') }));
  const index = newList.findKey(it => it.get('id') === -1 && it.get('origin') === '');

  if (index === undefined || index < 0) {
    newList = newList.push(
      Map({
        id: -1,
        name: '',
        origin: '',
        mode: config.VIEW_MODE,
      }),
    );
  }

  return switchToMode(newList, -1, config.EDIT_MODE);
}

/**
 * Switch a row in list to other mode.
 *
 * @param list {Immutable.List} List.
 * @param id {Number} Row id.
 * @param mode {String} Row's mode.
 */
export function switchToMode(list, id, mode) {
  return list.map(item => {
    if (item.get('id') === id) {
      return item.merge({
        name: mode === config.VIEW_MODE ? item.get('origin') : item.get('name'),
        mode,
      });
    }

    return item.set('mode', config.VIEW_MODE);
  });
}

/**
 * Switch all rows to view mode.
 *
 * @param list {Immutable.List} List.
 */
export function switchToView(list) {
  return list.map(item => item.merge({ mode: config.VIEW_MODE, name: item.get('origin') }));
}

/**
 * Change text of a row in list.
 *
 * @param list {Immutable.List} List.
 * @param id {Number} Row id.
 * @param text {String} Text.
 */
export function changeText(list, id, text = '') {
  const index = list.findKey(i => i.get('id') === id);

  if (index !== undefined && index > -1) {
    if (text.length) {
      return list.setIn([index, 'name'], text);
    }

    return list.set(
      index,
      Map({
        id: -1,
        name: '',
        origin: '',
        mode: config.VIEW_MODE,
        dirty: true,
      }),
    );
  }

  return list;
}

/**
 * Remove a row from list.
 *
 * @param list {Immutable.List} List.
 * @param id {Number} Row id.
 */
export function deleteRow(list, id) {
  const index = list.findKey(i => i.get('id') === id);

  if (index > -1) {
    return list.delete(index);
  }

  return list;
}

/**
 * Save selected suggestion to row.
 *
 * @param list {Immutable.List} List.
 * @param action {Object} Action.
 */
export function saveSuggestionToRow(list, action) {
  return list.map(item => {
    if (item.get('id') === action.id) {
      return Map({
        id: action.suggestionId,
        name: action.suggestionName,
        origin: action.suggestionName,
        mode: config.VIEW_MODE,
        dirty: true,
      });
    }

    return item.set('mode', config.VIEW_MODE);
  });
}

/**
 * Set all dirty fields to false.
 *
 * @param state {Immutable.Map} State response.
 */
export function clearDirty(state) {
  return state.map(user => user.set('dirty', false));
}

/**
 * Load suggestion list.
 *
 * @param state {Immutable.Map} State.
 * @param action {Object} Action.
 */
function loadProjectSuggestions(state, action) {
  if (action.response.status === 'success' && state.get('projectRequestId') === action.requestId) {
    return state.set(
      `${action.field}Suggestions`,
      fromJS(
        action.response.data.map(s => ({
          id: s.id,
          name: s.text,
        })),
      ),
    );
  }

  return state;
}

/**
 * Load suggestion list from response, check if request id matchs before loading.
 *
 * @param state {Immutable.Map} State.
 * @param action {Immutable.Map} Action.
 * @param type Type.
 */
function loadSuggestions(state, action, type) {
  let ret = List();

  if (action.response.status === 'success' && state.get(`${type}SuggestionRequestId`) === action.requestId) {
    ret = fromJS(
      action.response.data.map(user => ({
        id: user.id,
        name: user.text,
      })),
    );
  }

  if (type === 'industry') {
    return insertAddingRow(ret);
  }

  return ret;
}

/**
 * Insert an adding row at bottom.
 *
 * @param list {Immutable.List} List.
 */
function insertAddingRow(list) {
  return list.push(
    Map({
      id: -1,
      name: 'Add New Industry',
    }),
  );
}

function mapResponse(action) {
  return {
    ...action.response.data,
    projectLoading: false,
  };
}

function setValueAsOriginalByMap(state, map) {
  return spy(
    map.reduce((result, key) => {
      const value = getIn(result, key);

      return result.setIn(key.split('.'), value);
    }, state),
    map,
  );
}
